"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WowUrlConverterFactory = void 0;
var wow_interface_1 = require("@wowlink/wow-interface");
var converter_1 = require("./builtin_converters/exact/converter");
var WowUrlConverterFactory = function (type, config) {
    // TODO(@tianhaoz95): rename this to EXACT instead of BASIC to be more informative.
    if (type == wow_interface_1.BuiltInWowUrlConverterType.Basic) {
        return new converter_1.BasicWowLinkConverter(config);
    }
    else {
        throw new Error("Unknown converter type " + type + ".");
    }
};
exports.WowUrlConverterFactory = WowUrlConverterFactory;
